import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { AvailableSessionsPage } from './pages/AvailableSessionsPage';
import { DashboardPage } from './pages/DashboardPage';
import { HeadsetPairingPage } from './pages/HeadsetPairingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { SessionDetailPage } from './pages/SessionDetailPage';
import { SessionsPage } from './pages/SessionsPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="headset-pairing" element={<HeadsetPairingPage />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="available-sessions" element={<AvailableSessionsPage />} />
          <Route path="sessions/:id" element={<SessionDetailPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
